import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEnumEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchInstrumentMainTypesThunk: any = createAsyncThunk<IBindBaseEnumEntity[]>(
  `${prefix} fetchInstrumentMainTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getInstrumentMainTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch instrument main types. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
